<template>
    <svg viewBox="0 0 36 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 0.5625L22.4648 12.4172L35.119 13.0002L25.2242 20.9098L28.5801 33.1248L18 26.1585L7.41987 33.1248L10.7758 20.9098L0.880983 13.0002L13.5352 12.4172L18 0.5625Z" fill="currentColor"/>
    </svg>
</template>